module.exports = __webpack_public_path__ + "static/media/tag.353c3d4f.svg";